import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from 'lodash';

export class PlanningResourcesActionButtonCtrl implements IController {
  resources: any;
  selectedIds: Function;
  onCreateRoutes: Function;
  onPrintRoutes: Function;
  onDeleteRoutes: Function;
  onAddToDraft: Function;
  onRemoveFromDraft: Function;
  onReoptimizeRoutes: Function;

  public actions: any;

  /* @ngInject */
  constructor(private $timeout: ITimeoutService) {
  }

  $onInit() {
    this.actions = {};
  }

  onOpen($mdMenu, ev) {

    let routedResources: boolean = false;
    let unRoutedResources: boolean = false;
    let lockedResources: boolean = false;
    let includedResources: boolean = false;
    let excludedResources: boolean = false;
    let resourcesWithDispatchRoutes: boolean = false;
    let resourcesWithoutDispatchRoutes: boolean = false;

    _.forEach(this.selectedIds, (resourceId) => {

      const resource = _.find(this.resources, (r) => {
        return r.id === resourceId;
      });


      if (!routedResources && _.get(resource, 'routed')) {
        routedResources = true;
      }

      if (!unRoutedResources && !_.get(resource, 'routed')) {
        unRoutedResources = true;
      }

      if (!lockedResources && _.get(resource, 'locked')) {
        lockedResources = true;
      }


      if (!resourcesWithDispatchRoutes && _.get(resource, 'routed') && (_.get(resource, 'routeStatus') === 'DISPATCHED')) {
        resourcesWithDispatchRoutes = true;
      }

      if (!resourcesWithoutDispatchRoutes && (!_.get(resource, 'routed') || (_.get(resource, 'routeStatus') !== 'DISPATCHED'))) {
        resourcesWithoutDispatchRoutes = true;
      }

      if (!includedResources && !_.get(resource, 'excluded')) {
        includedResources = true;
      }

      if (!excludedResources && _.get(resource, 'excluded')) {
        excludedResources = true;
      }
    })

    this.actions = {
      dispatchRoutes: routedResources && !unRoutedResources,
      deleteRoutes: routedResources && includedResources && !lockedResources,
      addToDraft: !includedResources,
      removeFromDraft: !excludedResources && !lockedResources,
      resourcesWithDispatchRoutes: resourcesWithDispatchRoutes,
      resourcesWithoutDispatchRoutes: resourcesWithoutDispatchRoutes,
      reoptimizeRoutes: !lockedResources
    };

    this.$timeout(0).then(function () {
      $mdMenu.open(ev);
    });
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningResourcesActionButton', {
    bindings: {
      resources: '<',
      selectedIds: '<',
      onCreateRoutes: '&',
      onPrintRoutes: '&',
      onPrintRoutesLoadingSheet: '&',
      onDispatchRoutes: '&',
      onDeleteRoutes: '&',
      onAddToDraft: '&',
      onRemoveFromDraft: '&',
      onReoptimizeRoutes: '&'
    },
    template: require('./planning-resources-action-button.html').default,
    controller: PlanningResourcesActionButtonCtrl
  });
